module.exports = __webpack_public_path__ + "img/infibo-logo.c17da5e8.svg";